import { useEffect, useRef, useState } from 'react';

const THEME_SRC = '/audio/portfolio-theme.mp3';

export function PortfolioThemeControl() {
  const audio = useRef<HTMLAudioElement>(null);
  const [playing, setPlaying] = useState(false);
  const [muted, setMuted] = useState(false);
  const [reduced, setReduced] = useState(false);
  const [message, setMessage] = useState('재생하지 않음');

  useEffect(() => {
    const query = window.matchMedia('(prefers-reduced-motion: reduce)');
    const sync = () => {
      setReduced(query.matches);
      if (query.matches) {
        audio.current?.pause();
        setPlaying(false);
        setMessage('감각 자극 줄이기 설정으로 음악이 멈췄어요.');
      }
    };
    sync();
    query.addEventListener('change', sync);
    return () => query.removeEventListener('change', sync);
  }, []);

  const togglePlay = async () => {
    const player = audio.current;
    if (!player || reduced) return;
    if (!player.paused) {
      player.pause();
      setPlaying(false);
      setMessage('일시정지됨');
      return;
    }
    try {
      await player.play();
      setPlaying(true);
      setMessage('결과 음악 재생 중');
    } catch {
      setPlaying(false);
      setMessage('재생하지 못했어요. 다시 눌러 주세요.');
    }
  };

  const toggleMute = () => {
    const player = audio.current;
    if (!player) return;
    player.muted = !player.muted;
    setMuted(player.muted);
    setMessage(player.muted ? '음소거됨' : playing ? '결과 음악 재생 중' : '재생하지 않음');
  };

  return <section className="portfolio-theme" aria-labelledby="portfolio-theme-title">
    <div>
      <span className="eyebrow">선택해서 듣기</span>
      <h2 id="portfolio-theme-title">결과를 정리한 뒤 듣는 45초 음악</h2>
      <p>음악을 켜지 않아도 기록과 다음 행동은 그대로 확인할 수 있어요.</p>
    </div>
    <div className="portfolio-theme-actions">
      <button className="secondary" type="button" disabled={reduced} aria-pressed={playing} onClick={togglePlay}>{playing ? '일시정지' : '음악 재생'}</button>
      <button className="secondary" type="button" disabled={reduced} aria-pressed={muted} onClick={toggleMute}>{muted ? '소리 켜기' : '음소거'}</button>
      <span role="status" aria-live="polite">{message}</span>
    </div>
    <audio ref={audio} src={THEME_SRC} preload="none" onEnded={() => { setPlaying(false); setMessage('재생 완료'); }} />
  </section>;
}

